import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { KICK_RULES_LABEL } from "@common/constants/actor";
import { scheduleRuleSkipAuditMetadataSchema } from "@common/schemas/domains/accounting/scheduleRuleOutcome.schema";
import { SCHEDULE_RULE_SKIP_REASON_COPY } from "@common/constants/domains/accounting/scheduleRuleSkipReason";

interface Props {
    log: AuditLog;
}

export const TransactionLogScheduleRuleSkipContent: React.FC<Props> = ({
    log,
}) => {
    const parsed = scheduleRuleSkipAuditMetadataSchema.safeParse(log.metadata);
    if (!parsed.success) {
        return null;
    }
    const { templateName, reason } = parsed.data;

    return (
        <>
            <strong>{KICK_RULES_LABEL}</strong> didn't apply schedule
            {templateName ? (
                <>
                    {" "}
                    <strong>{templateName}</strong>
                </>
            ) : null}
            . {SCHEDULE_RULE_SKIP_REASON_COPY[reason]}
        </>
    );
};
